module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-5-svgrepo-com.df9f0e98.svg";